import onboardingVersions from '@/configs/onboarding.json';
import { OnboardingType } from '@/modules/account/types';
import { PageStore } from '@/modules/page/pageStore';

interface AccountData {
  _id?: string;
  onboarding?: Partial<Record<OnboardingType, string>>;
}

function compareVersionStrings(a: string, b: string): number {
  const aParts = a.split('.').map(Number);
  const bParts = b.split('.').map(Number);
  const length = Math.max(aParts.length, bParts.length);

  for (let i = 0; i < length; i++) {
    const aVal = aParts[i] ?? 0;
    const bVal = bParts[i] ?? 0;

    if (aVal > bVal) return 1;
    if (aVal < bVal) return -1;
  }

  return 0;
}

export function shouldShowOnboarding(
  accountData: AccountData,
  type: OnboardingType,
  pageStore: PageStore,
): boolean {
  if (!accountData._id) return false;
  if (pageStore.isOnboardingShown[type]) return false;

  const currentVersion = onboardingVersions[type];
  const seenVersion = accountData.onboarding?.[type];

  return !seenVersion || compareVersionStrings(seenVersion, currentVersion) < 0;
}
